import React from 'react'

export const Error = () => {
    return (
        <div>
            <p>
                Path does not exist!
            </p> 
        </div>
    )
}
